import React from "react";


export const CheckInSubmitted = () => {
    return <h4>Thanks! Your trainer will discuss with you at your next training session</h4>;
};
